import { remoteCall } from "../remoteservice/RemoteService";
class AutoRenew {
    static _inst = null;
    static getInstance() {
        if (!AutoRenew._inst) AutoRenew._inst = new AutoRenew();
        return AutoRenew._inst;
    }
    static update() {
        AutoRenew.getInstance().update();
    }

    _updated = false;
    _token = null;
    resetToken() {
        this._token = window.setTimeout(()=> {
            if (this._updated) this.refresh();
            this._token = null;
        }, 10 * 2 * 1000);
    }
    update() {
        this._updated = true;
        if (this._token) return;
        this.refresh();
        this.resetToken();
    }
    refresh() {
        this._updated = false;
        remoteCall('/dev-api/auth/refresh', {data:{}, type:'POST', loadingState:-1});
    }
}

export default AutoRenew;